// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"687":"cc996241","895":"e63840f8"}[chunkId] + ".chunk.css";
};